var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41683 10.8334C6.61345 10.8334 7.5835 11.8034 7.5835 13C7.5835 14.1967 6.61345 15.1667 5.41683 15.1667C4.22021 15.1667 3.25016 14.1967 3.25016 13C3.25016 11.8034 4.22021 10.8334 5.41683 10.8334Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 10.8334C14.1965 10.8334 15.1665 11.8034 15.1665 13C15.1665 14.1967 14.1965 15.1667 12.9998 15.1667C11.8032 15.1667 10.8332 14.1967 10.8332 13C10.8332 11.8034 11.8032 10.8334 12.9998 10.8334Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5833 10.8334C21.78 10.8334 22.75 11.8034 22.75 13C22.75 14.1967 21.78 15.1667 20.5833 15.1667C19.3867 15.1667 18.4167 14.1967 18.4167 13C18.4167 11.8034 19.3867 10.8334 20.5833 10.8334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon-more.e2cc3d986cb7eebc55159035ce674ae8.svg";
export { ForwardRef as ReactComponent };